import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { HelperService } from 'src/app/shared/helpers/helper.service';
import { environment } from 'src/environments/environment';
import { IdentialertSubSelectionModalComponent } from '../identialert-sub-selection-modal/identialert-sub-selection-modal.component';
import { IdentitableButtonEnum } from '../subscription-tables/desktop/subscription-table-desktop.component';
import { ProductLevel } from '../product-hero/product-hero.component';
import { ProductType, User } from 'src/app/interfaces/user';
import { MemberShipOptionsService } from 'src/app/services/membership-options/membership-options.service';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { UserService } from 'src/app/services/user/user.service';
import { isPlatformBrowser } from '@angular/common';
import { ConfigService } from '../../../../services/config/config.service';
import { PaymentConfigService } from 'src/app/services/payment-config/payment-config.service';

@Component({
  selector: 'app-identialert-page',
  templateUrl: './identialert-page.component.html',
  styleUrls: ['./identialert-page.component.scss']
})
export class IdentialertPageComponent implements OnInit, OnDestroy {

  public pricingPlans = environment.stripePlans;
  public IdentitableButtonEnum = IdentitableButtonEnum;
  public productLevels = ProductLevel;
  public buyButtonVisible: boolean = true;
  public user: User;
  public hasIdentiAlertOption: boolean = true;
  public isAuthenticated: boolean;
  public isBrowser: boolean;
  public plan2Name: string;
  public plan1Name: string;
  public isBrandPetlog: boolean;
  public plan2MonthlyPrice: string;
  private isUpgrade: boolean;

  private _subs: Subscription[] = [];
  private plan1Route: string;
  public plan2FeatureText1: string;
  public plan2FeatureText2: string;
  public plan2FeatureText3: string;
  public plan2FeatureText4: string;
  public secondarySubtitle: string;

  constructor(
    private _router: Router,
    private _helperService: HelperService,
    private _modalService: NgbModal,
    private _checkoutService: CheckoutService,
    private _logService: LogService,
    private route: ActivatedRoute,
    private membershipOptionsService: MemberShipOptionsService,
    private userService: UserService,
    private authManager: AuthManagerService,
    private configService: ConfigService,
    private paymentConfigService: PaymentConfigService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.plan1Route = this.configService.getTextFromKey('1-plan-route');
    this.isBrandPetlog = this.configService.isPetlogBrand();
    this.plan1Name = this.configService.getTextFromKey('1-plan-name');
    this.plan2Name = this.configService.getTextFromKey('2-plan-name');
    this.plan2FeatureText1 = this.configService.getTextFromKey('2-plan-feature-text-1');
    this.plan2FeatureText2 = this.configService.getTextFromKey('2-plan-feature-text-2');
    this.plan2FeatureText3 = this.configService.getTextFromKey('2-plan-feature-text-3');
    this.plan2FeatureText4 = this.configService.getTextFromKey('2-plan-feature-text-4');
    this.secondarySubtitle = this.configService.getTextFromKey('2-plan-page-hero-subtitle-text');
    this.plan2MonthlyPrice = this.paymentConfigService.getMonthlyDisplayPrice(
      ProductType.Premium,
      this.configService.getTextFromKey('2-plan-monthly-price')
    );
  }

  ngOnInit() {
    this.isAuthenticated = this.authManager.isAuthenticated;
    if (this.isAuthenticated) {
      this.userService.getMe().subscribe((userResponse: User) => {
        this.user = userResponse;
        this.hasIdentiAlertOption = this.membershipOptionsService.identiAlertAvailable(this.user);
        this.isUpgrade = this.user.productType === ProductType.Basic;
      });
    }

    if (this.isBrowser) {
      const currentUrl = window.location.search;
      const params = new URLSearchParams(currentUrl);
      const learnValue = params.get('learn')
      if (learnValue !== null && learnValue.toLowerCase() === 'true') {
        this.buyButtonVisible = false;
      }
    }
  }

  ngOnDestroy() {
    this._subs.forEach(it => it.unsubscribe());
  }

  public compareClick() {
    this._helperService.scrollToElementById('subscription-table');
  }

  public buyIdentialertAnnualSubscription() {
    this._checkoutService
    .checkout(
      [environment.stripePlans.identiAlertAnnual],
      { isUpgrade: this.isUpgrade }
    ).subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      (err) => {}
    );
  }

  public buyIdentiAlertSubscription() {
    if (!this.plan2MonthlyPrice) {
      this.buyIdentialertAnnualSubscription();
      return;
    }
    const identialertSubSelectionModalRef = this._modalService.open(IdentialertSubSelectionModalComponent, {
      backdrop: 'static',
      centered: true,
      size: 'md',
    });
    identialertSubSelectionModalRef.componentInstance.modalRef = identialertSubSelectionModalRef;
  }

  public navigateToIdentibasePlusPage() {
    this._router.navigate([this.plan1Route]);
  }

  public onIdentitableButtonClicked(buttonClickedName: string) {
    switch (buttonClickedName) {
      case IdentitableButtonEnum.IdentibasePlusButton:
        this.navigateToIdentibasePlusPage();
        break;
      case IdentitableButtonEnum.IdentialertButton:
        if (this.isBrandPetlog) {
          this.buyIdentialertAnnualSubscription();
        } else {
          this.buyIdentiAlertSubscription();
        }
        break;
    }
  }

}
